
export function getScrollValue(activeElem:string){
    const elActive = document.querySelector(activeElem) as HTMLElement;
    let offset: number;
    if(elActive !== null) {
        offset = elActive.offsetLeft;
    } else {
        offset = 0;
    }
    const intFrameWidth = window.innerWidth;

    let width: number;
    if(elActive !== null) {
        width = elActive.offsetWidth;
    } else {
        width = 0;
    }
    return (offset - intFrameWidth / 2) + (width / 2);
}